import { usePhoneVerificationMutation, useSendSmsMutation } from './gql/graphql.v3.generated';

export const usePhoneVerification = () => {
  const [sendSms, {
    loading: sendSmsLoading,
  }] = useSendSmsMutation();

  const [phoneVerification, {
    loading: phoneVerificationLoading,
  }] = usePhoneVerificationMutation();

  return {
    sendSmsLoading,
    phoneVerificationLoading,
    sendSms,
    phoneVerification,
  };
};
